import { SystemIcon, Button, Typography } from '@wishket/design-system';

import ContentContainer from './Container';

interface ErrorProps {
  onRetry: () => void;
}

const Error = ({ onRetry }: ErrorProps) => {
  return (
    <ContentContainer className="gap-[22px]">
      <Typography
        variant="body1"
        className="whitespace-pre-line text-center font-bold text-w-gray-900"
      >
        {'점괘가 도망갔어요!\n요고가 후다닥 잡아올게요'}
      </Typography>
      <Button
        variant="outlined"
        size="sm"
        className="flex items-center gap-1"
        onClick={onRetry}
      >
        <SystemIcon name="small_cat" className="text-primary" />
        <Typography variant="body2">다시보기</Typography>
      </Button>
    </ContentContainer>
  );
};

export default Error;
